import { useState } from 'react';
import { useParams } from 'react-router';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { Box, Button, Grid, MenuItem, Stack, TextField } from '@mui/material';

import { useGetDistrictsQuery } from '@/services';
import { AppBar, Empty, Error, Loader } from '@/components';
import { OrderDirections, ORDER_DIRECTIONS } from '@/utils/order-directions';

import { DistrictsTable, CreateDistrict } from './components';

const DistrictsPage: React.FC = () => {
  const { areaId } = useParams<{ areaId: string }>();

  const [{ order_direction, page }, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    order_direction: withDefault(StringParam, OrderDirections.DESC),
  });

  const [createModalOpened, setOpenedCreateModal] = useState(false);

  const {
    data: districts,
    isLoading,
    isSuccess,
    isError,
  } = useGetDistrictsQuery({ params: { order_direction, page, order_by: 'id', parent_id: areaId } });

  return (
    <>
      <AppBar title="Округи" />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
            <Box sx={{ width: 310 }}>
              <TextField
                select
                value={order_direction}
                label="Сортировать по"
                disabled={isLoading}
                onChange={(event) => setQuery({ order_direction: event.target.value })}
                variant="filled"
                fullWidth
                size="small"
              >
                {ORDER_DIRECTIONS.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box sx={{ width: 210 }}>
              <Button
                disabled={isLoading}
                onClick={() => setOpenedCreateModal(true)}
                size="large"
                variant="contained"
                fullWidth
              >
                Добавить
              </Button>
            </Box>
          </Stack>
        </Grid>

        <Grid item lg={6} xs={12}>
          {isLoading ? (
            <Loader />
          ) : isError ? (
            <Error text="Произошла ошибка с загрузкой округов! Пожалуйста, попробуйте позже" />
          ) : isSuccess && Boolean(districts?.data?.length) ? (
            <DistrictsTable list={districts} page={page} onChangePage={(page) => setQuery({ page })} />
          ) : (
            <Empty text="Округи отсутствуют" />
          )}
        </Grid>
      </Grid>

      <CreateDistrict onClose={() => setOpenedCreateModal(false)} open={createModalOpened} />
    </>
  );
};

export default DistrictsPage;
